import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA } from '../api/gesttor'
import { paramsUsuarioPayload, usuariosCadastrarPayload, usuariosAtualizarPayload, atualizarAvatarUsuario } from '../../interfaces/usuarios'

export function cadastrarUsuario (payload: usuariosCadastrarPayload) {
    return BASEURLGESTTOR.post('/usuario', payload)
}

export function listarUsuariosOrganizacao (params: paramsUsuarioPayload) {
    return BASEURLGESTTOR.get (`/usuario?termo=${params.termo}&situacao=${params.situacao}&idGrupo=${params.idGrupo || ""}`)
}

export function atualizarUsuario (idUsuario: string, payload: usuariosAtualizarPayload) {
    return BASEURLGESTTOR.patch (`/usuario/${idUsuario}`, payload)
}

export function dadosUsuario () {
    return BASEURLGESTTOR.get ('/usuario/dados')
}

export function atualizarAvatar (payload: atualizarAvatarUsuario) {
    return BASEURLGESTTORFORMDATA.put('/usuario/avatar', payload)
}

export function listarConvidados (payload: {idUsuarioConvite: string, valorNivel: string}) {
    return BASEURLGESTTOR.get(`/convidados/${payload.idUsuarioConvite}/${payload.valorNivel}`)
}

export function listarTicketSuperConectado (idRecompensa: string) {
    return BASEURLGESTTOR.get(`/conquista/superConectado/${idRecompensa}`)
}

